export default __webpack_public_path__ + "static/media/fl-icon-32-dark.d2f1c75d.svg";